// extracted by mini-css-extract-plugin
export default {"headcontainer":"contactus_headcontainer__Evufv","hr":"contactus_hr__Nf+7M","card":"contactus_card__bfJqh"};